/* eslint-disable @typescript-eslint/no-explicit-any */

export const mapToAddFormItem = (value: string, data?: Record<string, any>) => {
  return {
    label: value,
    data: data || null,
  };
};